import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, useAuth } from "../App";
import ProductCard from "../components/ProductCard";
import { Skeleton } from "../components/ui/skeleton";
import { Percent } from "lucide-react";

const OutletPage = () => {
  const { token } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API}/products`, { 
          params: { outlet: true },
          headers: { Authorization: `Bearer ${token}` }
        });
        setProducts(response.data);
      } catch (error) {
        console.error("Failed to fetch products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [token]);

  return (
    <div className="min-h-screen bg-black" data-testid="outlet-page">
      {/* Header */}
      <div className="p-4 space-y-2 border-b border-white/10 bg-gradient-to-b from-red-500/10 to-transparent">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center">
            <Percent className="text-red-500" size={24} />
          </div>
          <div>
            <h1 className="text-2xl font-light text-white tracking-wide">Outlet</h1>
            <p className="text-sm text-white/60">Occasioni imperdibili</p>
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="p-4">
        {loading ? (
          <div className="grid grid-cols-2 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="space-y-3">
                <Skeleton className="aspect-square w-full bg-zinc-800" />
                <Skeleton className="h-3 w-3/4 bg-zinc-800" />
                <Skeleton className="h-4 w-1/2 bg-zinc-800" />
              </div>
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20 text-white/60">
            <Percent size={64} className="mx-auto mb-4 opacity-30" />
            <p className="text-lg mb-2">Nessun prodotto in outlet</p>
            <p className="text-sm">Torna presto per nuove occasioni!</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-4">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OutletPage;
